"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Style_1 = require("./Style");
function adj(style) {
    const { textAlign = "center" } = style;
    style.textAlign = textAlign;
    return style;
}
let defaultStyle;
class IconStyle extends Style_1.Style {
    static get DEFAULT() {
        return defaultStyle ? defaultStyle : (defaultStyle = new IconStyle());
    }
    constructor(style = {}) {
        super(adj(style));
    }
    clone() {
        return new IconStyle(this);
    }
}
exports.IconStyle = IconStyle;
